import React from "react";
import { ClipboardCheckIcon, NetworkIcon, FileSpreadsheetIcon, MessageSquareTextIcon, ListChecksIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { toolkit } from "../../data/content";
const icons = [ClipboardCheckIcon, NetworkIcon, FileSpreadsheetIcon, MessageSquareTextIcon, ListChecksIcon];
export function ToolkitSection() {
  return <section className="bg-paper px-4 py-16 sm:py-24" data-id="element-316" data-mp="12phtkrzi04ju">
      <div className="mx-auto max-w-4xl" data-id="element-317" data-mp="xxzopsuctjtl">
        <SectionHeading tone="light" kicker="Your clinical review toolkit" title="Practical resources to put the blueprints to work" intro="Along with the six volumes, you'll receive a collection of practical resources designed to help you apply the framework to your own workflow." data-id="element-318" data-mp="xx7v2nkbhw5y" />

        <ul className="mt-12 divide-y divide-navy/10 rounded-3xl bg-white px-5 shadow-sm ring-1 ring-navy/5 sm:px-8" data-id="element-319" data-mp="k0b9b0j234vx">
          {toolkit.map((t, i) => {
          const Icon = icons[i];
          return <li key={t.title} className="flex gap-4 py-5 sm:py-6" data-id="element-320" data-mp="k20reeh7otfk" data-mpi={i}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-navy" data-id="element-321" data-mp="k3bxiky4qd9u">
                  <Icon className="h-6 w-6 text-brand" aria-hidden="true" data-id="element-322" data-mp="68ja70bzzssp" />
                </span>
                <div data-id="element-323" data-mp="b7mgeo3ps529">
                  <h3 className="text-lg font-extrabold leading-snug text-navy" data-id="element-324" data-mp="yzbbgc7x77mw">{t.title}</h3>
                  <p className="mt-1 text-base leading-relaxed text-navy/70" data-id="element-325" data-mp="130wllpt2l7te">{t.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-center text-base leading-relaxed text-navy/70" data-id="element-326" data-mp="p0lx2tf8g5be">
          The exact clinical decisions will always depend on the individual patient, the available diagnostic information,
          and your professional judgment. My intention is to give you a practical structure — not a one-size-fits-all
          prescription.
        </p>

        <div className="mt-10" data-id="element-327" data-mp="2un9sq4rwra7m">
          <CTAButton label="Yes, I want the complete system" data-id="element-328" data-mp="2unjmm3g2q1il" />
        </div>
      </div>
    </section>;
}